---
title: Predictive technology for computational social science
slug: now
type: now
status: published
featured: true
summary: Current focus — behavioral prediction in production, executable architecture, and conversations with teams who have to operate both.
sitePublishedAt: "2026-09-18"
lastReviewedAt: "2026-10-03"
audiences:
  - business
  - product-developer
themes:
  - prediction-in-production
  - platform-architecture
  - network-analysis
originalAuthor: Jay van Zyl
sourceRelationship: first-party quarterly snapshot
rightsStatus: first-party
seoDescription: What Jay van Zyl is working on now — platforms, graph methods, workshops, and writing.
canonicalPath: /now
period: 2026-Q3
---

I am working on the join between behavioral prediction and executable architecture.

## Products

ecosystem.Ai is four systems in production: a workbench, a prediction server, the Client Pulse Responder, and data agents, with dynamic algorithms including Network Analysis. EcosystemCode is the modeling workbench plus the public domain catalog — the path from a validated model to a running baseline.

## Teaching

Teaching Associate at Henley Business School and Stellenbosch University. The courses are AI, the new world of work, and AI and behavior. The classroom argument is the one on [Teaching](/teaching).

## Conversations

Workshops with leadership teams who need prediction as an operating capability, and with architects who need the prediction to stay reliable for the human in the interaction.

## Writing

I write the notes on this site. I also post on LinkedIn.
